import { FaEdit } from "react-icons/fa";
import { MdOutlineDeleteOutline } from "react-icons/md";

import Loader from "../../Loader";
import EmptyTable from "../../EmptyTable";

const AcademicSessionTable = ({
  data,
  loading,
  selected,
  handleEdit,
  handleDelete,
  handleActivate,
}) => {
  return (
    <div className="table_wrapper">
      <div className="min-w-[700px]">
        {/* table header */}
        <div className="grid grid-cols-6 border-b">
          <div className="col-span-2 border-r p-3">
            <h5 className="font-semibold text-sm">Session</h5>
          </div>

          <div className="p-3 border-r">
            <h5 className="font-semibold text-sm">Next Session</h5>
          </div>

          <div className="border-r p-3">
            <h5 className="font-semibold text-sm">Status</h5>
          </div>

          <div className="p-3 border-r">
            <h5 className="font-semibold text-sm">Date Created</h5>
          </div>

          <div className="p-3">
            <h5 className="font-semibold text-sm">Action</h5>
          </div>
        </div>

        {loading ? <Loader loading={loading} /> : null}

        {!loading && !data?.length ? (
          <EmptyTable
            // image={subjectBookImage}
            message={"No subject records found"}
          />
        ) : null}

        {/* Table body */}
        {data?.map((item, i) => (
          <div
            className={`grid grid-cols-6 border-b table_row hover:active_table_row ${
              selected === item?.academicSessionId ? "active_table_row" : ""
            }`}
            key={i}
          >
            <div className="col-span-2 border-r p-3">
              <p className="text-independence text-sm capitalize">
                {item?.session}
              </p>
            </div>

            <div className="p-3 border-r">
              <p className="text-independence text-sm capitalize">
                {item?.nextSession}
              </p>
            </div>

            <div className="border-r p-3" onClick={() => handleActivate(item)}>
              <p className="text-sm capitalize">
                {item?.isActive ? (
                  <span className="text-primary font-semibold">Active</span>
                ) : (
                  <span className="text-morning_blue hover:text-primary hover:font-semibold block w-full">
                    Set as active
                  </span>
                )}
              </p>
            </div>

            <div className="p-3 border-r">
              <p className="text-independence text-sm">
                {new Date(item?.createdAt)?.toLocaleDateString()}
              </p>
            </div>

            <div className="px-3 flex items-center gap-2">
              <button
                onClick={() => handleEdit(item)}
                className="text-independence h-8 w-8 rounded-full flex items-center justify-center cursor-pointer hover:bg-primary hover:text-white"
              >
                <FaEdit className="text-base" />
              </button>

              <button
                onClick={() => handleDelete(item)}
                className="text-independence h-8 w-8 rounded-full flex items-center justify-center cursor-pointer hover:bg-coral_red hover:text-white"
              >
                <MdOutlineDeleteOutline className="text-lg" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AcademicSessionTable;
